import { dataLayer, getPageTitle } from './gtm';

export default (advisor) => {
  let pageTitle = getPageTitle();

  const data = {
    event: 'pageview',
    pageview: {
      pagepath: (window.location.pathname + window.location.hash.replace(/#\//g, '')),
      pageurl: window.location.href.replace(/\/#/g, ''),
      pagetitle: `hub - web - lg - ${pageTitle}`,
    },
    user: {
      userId: advisor.login,
      advisorType: advisor.advisorType,
      businessType: advisor.businessType,
      officeCode: advisor.officeCode,
      assessorId: advisor.id,
      tipo_assessor: advisor.advisorType,
      canal_cliente: advisor.businessType,
      id_filial: advisor.officeCode,
      codigo_assessor: advisor.id
    },
  };

  dataLayer.push(data);
}
